const FaqContentLanding = [
  {
    title: 'What are the benefits of driving with Autzu?',
    info: [
      { pretext: 'Here are the benefits of driving with Autzu:' },
      {
        text: [
          {
            boldtext: 'Access to Electric Vehicles (EVs): ',
            plaintext:
              'With Autzu, you can access electric vehicles, allowing you to earn more on rideshare platforms while saving on charging costs compared to gasoline.'
          },

          {
            boldtext: 'No Long-Term Commitment: ',
            plaintext:
              'Autzu offers hourly and daily rentals allowing you to use the vehicle only when needed, without being tied down to long-term contracts or loans.'
          },
          {
            boldtext: 'Cost-Effective: ',
            plaintext:
              'Depending on the demand and availability, rental fees are competitive, allowing drivers to optimize their earnings.'
          },
          {
            boldtext:
              'No Need for Personal Vehicle Ownership or Wear and Tear: ',
            plaintext:
              "Using Autzu's vehicles for ridesharing or delivery means less wear and tear on your personal vehicle, creating substantial savings on maintenance and depreciation costs in the long run."
          },
          {
            boldtext: 'Environmental Benefits: ',
            plaintext:
              'By promoting the use of electric vehicles, drivers are contributing to reduced carbon emissions and promoting a more sustainable future.'
          }
        ]
      }
    ]
  },
  {
    title: 'When can I drive?',
    info: [
      {
        pretext: 'The following hours are when you can start your booking:'
      },
      { text: { plaintext: '1am, 3am, 5am, 7am, 9am, 11am' } },
      { text: { plaintext: '1pm, 3pm, 5pm, 7pm, 9pm, 11pm' } },
      {
        mixedPosttext: {
          leadingPosttext: 'Bookings must be a',
          boldPosttext: ' minimum of 6 hours, ',
          postingPosttext:
            'and you have the option to extend them in increments of 2 hours.'
        }
      },
      {
        mixedPosttext: {
          leadingPosttext: 'Alternatively, ',
          boldPosttext: 'you can choose daily bookings, ',
          postingPosttext:
            'allowing you to reserve a vehicle for up to a maximum of 7 days.'
        }
      }
    ]
  },
  {
    title: 'How does payment work?',
    info: [
      {
        text: [
          {
            boldtext: 'Rental Fee Charge: ',
            plaintext:
              'The rental fee for your booking will be charged to your payment method two hours prior to your booking begins.'
          },

          {
            boldtext: 'Extension & Supercharging Charges: ',
            plaintext:
              'If you decide to extend your booking or if you complete a Supercharging session, charges will be applied immediately after each respective action.'
          },
          {
            boldtext: 'Additional Fees: ',
            plaintext:
              'Any other fees (i.e. late fees or low-charge fees)  that may arise during your rental period will be charged at the end of your booking.'
          },
          {
            boldtext: 'Accepted Payment Methods: ',
            plaintext:
              'Autzu accepts all major credit and virtual debit cards.'
          }
        ]
      }
    ]
  }
];

export default FaqContentLanding;



// WEBPACK FOOTER //
// ./src/components/Static/LandingPage/FaqContentLanding.js